
import React from 'react';

import { BrowserRouter as Router, Route, HashRouter } from 'react-router-dom'
import Database from './database';
import firebase from 'firebase';

import Notifications from 'react-notify-toast';

import Analytics from './helpers/analytics';

import Signup from './signup';
import SignupEmail from './signup.email';
import Games from './games/';
import Create from './games/create';
import Game from './game/';
import JoinGame from './join';

// import Footer from './footer';
import Loading from './loading';

class Index extends React.Component {

	constructor(props) {
		super(props);

		this.state = {
			user: null
		}

	}

	componentDidMount () {

		this.authListener = firebase.auth().onAuthStateChanged((user) => {
			// console.log('onAuthStateChanged',user);
			this.setState({
				user: user || null
			})
		})
	}
	componentWillUnmount () {
		this.authListener()
	}

	render() {
		return <Router>

		<div>

		<Notifications />

		<Route path="/" component={Analytics}/>>

		{/* Home Screen */}
		<Route exact path="/" render={() => (
			this.state.user ? <Games user={this.state.user}/>:<Signup/>
		)}/>

		<Route exact 	path="/signup/email" 		component={SignupEmail}/>
		<Route exact 	path="/games/" 				render={()=>(
			this.state.user ? <Games user={this.state.user} />:<Loading />
		)}/>
		<Route exact 	path="/games/create/" 		render={()=>(
			this.state.user ? <Create user={this.state.user}/>:<Loading />
		)}/>

		<Route exact	path="/game/:gameId/*" 		render={(routeProps)=>(
			<Game {...routeProps} user={this.state.user} gameId={routeProps.match.params.gameId} />
		)}/>
		<Route exact	path="/join/:gameId/*" 		render={(routeProps)=>(
			this.state.user ? <JoinGame {...routeProps} user={this.state.user} gameId={routeProps.match.params.gameId} />: <Loading/>
		)}/>

		</div>
		</Router>
	}
}

export default Index;



// WEBPACK FOOTER //
// ./src/components/index.js